export default function languageDetector(locale?: 'de' | 'en'): 'de' | 'en' {
  if (locale) {
    return locale
  }

  const langs: { de: 'de'; en: 'en'; 'de-DE': 'de' } = { de: 'de', en: 'en', 'de-DE': 'de' }

  if (navigator.language === 'de' || navigator.language === 'de-DE') {
    return langs[navigator.language as keyof typeof langs]
  }

  return 'en'
}
